<template>
  <b-container>
    <div v-if="isRequestingUserData">
      <spinner-loader :loading="isRequestingUserData" />
    </div>
    <div v-else>
      <b-jumbotron
        style="
          background-image: url(https://source.unsplash.com/h2Uf8Kd6MN0);
          background-size: cover;
        "
        img-alt="Image"
        img-right
        class="profile-header mb-2"
      >
        <b-button class="editButton" variant="primary" @click="editOrSubmit">{{
          editButtonText
        }}</b-button>
        <picture-placeholder
          :textIn="formData.first_name + ' ' + formData.last_name"
          :pictureUrl="formData.photo_uri"
        />
      </b-jumbotron>
      <div class="user-account-info" v-if="!isEditing">
        <div class="user-account-name">
          {{ formData.first_name + " " + formData.last_name }}
        </div>
        <span v-if="formData.sex">
          <span v-if="'MALE' == formData.sex.toUpperCase()">♂</span>
          <span v-else-if="'FEMALE' == formData.sex.toUpperCase()">♀</span>
          <span v-else>⚦⚲</span>
        </span>
        <span v-if="formData.birthday"> 🎂{{ formData.birthday }} </span>
        <p class="card-text">Premium Member since 2019</p>
      </div>
      <b-form @submit="handleSubmit">
        <div class="edit-account-form" v-if="isEditing">
          <b-row class="account-full-name">
            <b-col size="sm">
              <b-form-input
                id="first_name"
                type="text"
                v-model="formData.first_name"
                placeholder="first"
              />
            </b-col>
            <b-col size="sm">
              <b-form-input
                id="middleNameInput"
                type="text"
                v-model="formData.middle_name"
                placeholder="middle"
              />
            </b-col>
            <b-col size="sm">
              <b-form-input
                id="last_name"
                type="text"
                v-model="formData.last_name"
                placeholder="last"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-radio-group v-model="formData.sex">
                <b-form-radio value="male">♂ Male</b-form-radio>
                <b-form-radio value="female">♀ Female</b-form-radio>
                <b-form-radio value="unknown">⚦⚲ Decline</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row size="small">
            <b-col cols="6" size="sm" class="input-group birthday-row">
              <div class="input-group-prepend">
                <span class="input-group-text">🎂</span>
              </div>

              <b-form-input
                id="birthdayInput"
                type="date"
                v-model="formData.birthday"
              />
            </b-col>
          </b-row>
        </div>
      </b-form>
      <b-card-group
        columns
        style="margin-top: 75px; padding-top: 16px; column-count: 2"
        class="mb-4"
        deck
      >
        <b-card style="max-width: 24rem" class="mb-2" title="About Me">
          <div v-if="!isEditing">
            {{ formData.citizenship }}
            <br />
            {{ formData.country }}
          </div>
          <div class="social-form" v-else>
            <i class="fi-compass" />
            <b-form-input
              id="citizenshipInput"
              type="text"
              v-model="formData.citizenship"
              placeholder="citizenship"
            />
            <i class="fi-home" />
            <b-form-input
              id="countryInput"
              type="text"
              v-model="formData.country"
              placeholder="home country"
            />
          </div>
        </b-card>

        <b-card style="max-width: 24rem" class="mb-2" title="Contact">
          <div v-if="!isEditing">
            {{ formData.email }}
            <br />
            {{ formData.address }}
          </div>
          <div class="social-form" v-else>
            <i class="fi-map" />
            <b-form-input
              id="addressInput"
              type="text"
              v-model="formData.address"
              placeholder="address"
            />
            <i class="fi-mail" />
            <b-form-input
              id="email"
              type="email"
              v-model="formData.email"
              placeholder="email"
            />
            <i class="fi-telephone" />
            <b-form-input id="phoneInput" type="tel" v-model="formData.phone" />
          </div>
        </b-card>

        <b-card style="max-width: 24rem" class="mb-2" title="Social">
          <div v-if="!isEditing">
            <a :href="formData.facebook" target="_blank">
              <i v-if="null != formData.facebook" class="fi-social-facebook" />
            </a>
            <a :href="formData.instagram" target="_blank">
              <i
                v-if="null != formData.instagram"
                class="fi-social-instagram"
              />
            </a>
            <a :href="formData.twitter" target="_blank">
              <i v-if="null != formData.twitter" class="fi-social-twitter" />
            </a>
            <a :href="formData.pinterest" target="_blank">
              <i
                v-if="null != formData.pinterest"
                class="fi-social-pinterest"
              />
            </a>
            <a :href="formData.snapchat" target="_blank">
              <i v-if="null != formData.snapchat" class="fi-social-snapchat" />
            </a>
          </div>
          <div class="social-form" v-else>
            <i class="fi-social-facebook" />
            <b-form-input
              id="facebookInput"
              type="url"
              v-model="formData.facebook"
            />
            <i class="fi-social-instagram" />
            <b-form-input
              id="instagramInput"
              type="url"
              v-model="formData.instagram"
            />
            <i class="fi-social-twitter" />
            <b-form-input
              id="twitterInput"
              type="url"
              v-model="formData.twitter"
            />
            <i class="fi-social-pinterest" />
            <b-form-input
              id="pinterestInput"
              type="url"
              v-model="formData.pinterest"
            />
            <i class="fi-social-snapchat" />
            <b-form-input
              id="snapchatInput"
              type="url"
              v-model="formData.snapchat"
            />
          </div>
        </b-card>
      </b-card-group>

      <div v-if="isUpdatingUser">
        <spinner-loader :loading="isUpdatingUser" />
      </div>
      <div v-else>
        <b-button
          ref="submitBtn"
          id="submitBtn"
          type="submit"
          @click="editOrSubmit"
          variant="primary"
          >Save</b-button
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import SpinnerLoader from "@/components/widgets/SpinnerLoader";
import PicturePlaceholder from "@/components/widgets/PicturePlaceholder";

import { mapState } from "vuex";
export default {
  data() {
    return {
      formData: {},
      isEditing: false,
      editButtonText: "EDIT",
    };
  },
  async created() {
    await this.$store
      .dispatch("getUserData")
      .then(() => {
        console.dir(this.$store.getters.getUser);
      })
      .catch((err) => {
        console.dir(err);
      });

    this.formData = Object.assign({}, this.$store.getters.getUser); // copy part of the global state to component local state
    console.log(this.formData);
  },
  computed: {
    ...mapState({
      isRequestingUserData: (state) => state.auth.isRequestingUserData,
      isUpdatingUser: (state) => state.auth.isUpdatingUser,
    }),
  },
  methods: {
    handleSubmit() {
      this.$store
        .dispatch("updateUserData", this.formData)
        .then((msg) => {
          console.dir(msg);
          this.editButtonText = "EDIT";
          this.isEditing = false;
        })
        .catch((err) => {
          alert("fml: " + err);
        });
    },
    editOrSubmit() {
      if (!this.isEditing) {
        this.isEditing = true;
        this.editButtonText = "SAVE";
      } else {
        this.handleSubmit();
      }
    },
  },
  components: {
    SpinnerLoader,
    PicturePlaceholder,
  },
};
</script>

<style lang="scss" scoped>
.social-form {
  input.form-control {
    display: inline;
    width: 85%;
  }
}

.profile-header {
  margin-top: 25px;
  position: relative;
  min-height: 200px;

  .editButton {
    position: absolute;
    right: 12px;
    top: 12px;
  }
}

.user-account-info {
  width: 20%;
  line-height: 1.3;
  margin-left: 190px;

  .user-account-name {
    font-size: 18pt;
  }
}

.edit-account-form {
  width: 60%;
  margin: auto;
  padding-top: 10px;

  .birthday-row {
    margin: auto;
  }

  .row {
    margin-bottom: 10px;
  }
}

i {
  color: #444;
  position: relative;
  top: 6px;
  font-size: 24pt;
}

i:hover {
  color: #888;
}

input {
  text-align: center;
}

#submitBtn {
  display: none;
}

.picture-placeholder-container {
  position: absolute;
  width: 150px;
  height: 150px;
  text-align: center;
  background: #898c7f;
  bottom: -60px;
  left: 40px;
}

.picture-placeholder-picture {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
}

.picture-placeholder-initials {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 36pt;
}
</style>
